import { useSyncExternalStore } from 'react';

interface ConfirmOptions {
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'default' | 'destructive';
}

interface ConfirmState {
  open: boolean;
  options: ConfirmOptions | null;
  resolve: ((value: boolean) => void) | null;
}

let state: ConfirmState = { open: false, options: null, resolve: null };
const listeners = new Set<() => void>();

function emitChange() {
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return state;
}

export function confirm(options: ConfirmOptions): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    state = { open: true, options, resolve };
    emitChange();
  });
}

export function closeConfirm(result: boolean) {
  state.resolve?.(result);
  state = { open: false, options: null, resolve: null };
  emitChange();
}

export function useConfirmState() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
